// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffcommon/v1/feature_flag_service.proto (package bffcommon.v1, syntax proto3)
/* eslint-disable */

import { FeatureFlagService } from "./feature_flag_service_pb";

/**
 * @generated from rpc bffcommon.v1.FeatureFlagService.ListFeatureFlags
 */
export const listFeatureFlags = FeatureFlagService.method.listFeatureFlags;
